import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { VerticalInfosComponentModule } from './vertical-infos/vertical-infos.component';
import { ToolBarComponentModule } from './tool-bar/tool-bar.component';
import { MainMenuComponentModule } from './main-menu/main-menu.component';
import { IcilaluneLogoComponentModule } from './icilalune-logo/icilalune-logo.component';
import { ObserversModule } from '@angular/cdk/observers';
import { RouterStaticLinkDirectiveModule } from '@icilalune/utils';
import { MainHeaderComponentModule } from './main-header/main-header.component';
import { SvgIconComponentModule } from '@nx-icilalune/icilalune/media';
import { LoadingDirective } from '@nx-icilalune/icilalune/loading';
import { SettingsLinkComponent } from './settings-link/settings-link.component';
import { PushModule } from '@ngrx/component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    VerticalInfosComponentModule,
    ToolBarComponentModule,
    MainMenuComponentModule,
    IcilaluneLogoComponentModule,
    ObserversModule,
    RouterStaticLinkDirectiveModule,
    MainHeaderComponentModule,
    SvgIconComponentModule,
    LoadingDirective,
    SettingsLinkComponent,
    PushModule,
  ],
  declarations: [],
  exports: [],
})
export class IcilaluneShellUiModule {}
